import { validationRules } from "@/constants/global";

export const validation = {
  data() {
    return {
      requiredRule: validationRules.required,
      nameRule: validationRules.name
    };
  },
  methods: {
    validateForm(refName) {
      this.$refs[refName].validate();
    }
  }
};
